<template>
  <div class="c-selecter">
    <Row>
      <Col ref="bar" :span="maxCol" class="c-select-box">
        <Row class="c-select-flex">
          <Col v-for="(box, idx) in resource" :span="col" :key="idx" class="c-selecter-item">
            <select-item v-model="box.keyword" :title="box.title" :disabled="disabled" :search="search" :loading="loading">
              <select-box
                v-model="box.current"
                :data="box.data"
                :level="box.level"
                :keyword="box.keyword"
                :disabled="disabled"
                :enable-select-all="enableSelectAll"
                :no-select-all="noSelectAll"
                @on-child="pushChild"
                @on-select="selectAll"
              />
            </select-item>
          </Col>
        </Row>
      </Col>
      <Col span="8">
        <select-item v-if="1" :title="resultTitle" clear @on-clear="$emit('on-clear', { list: data })">
          <div v-for="item in result" :key="item.id" class="c-pop-tip">
            <Tag :name="item.key" closable class="c-tag-item" @on-close="handleClose">{{ item.name }}</Tag>
          </div>
        </select-item>
      </Col>
    </Row>
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
import SelectItem from './select-item.vue'
import SelectBox from './select-box.vue'
export default {
  name: 'selecter',
  components: { SelectItem, SelectBox },
  props: {
    value: {
      type: Array
    },
    title: {
      type: Array
    },
    data: {
      type: Array
    },
    transfer: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    resourceTitle: {
      type: Boolean
    },
    search: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number
    },
    enableSelectAll: {
      type: Boolean,
      default: false
    },
    noSelectAll: {
      type: Boolean
    },
    loading: {
      type: Boolean
    }
  },
  data() {
    return {
      resource: []
    }
  },
  computed: {
    maxCol() {
      return this.transfer ? 16 : 24
    },
    col() {
      return 24 / this.resource.length
    },
    result() {
      return this.value
    },
    resultLen() {
      return this.value.length
    },
    resultTitle() {
      return `已选${this.max > 0 ? '(' + this.resultLen + `/${this.max}` + ')' : '(' + this.resultLen + ')'}`
    }
  },
  watch: {
    data(nVal) {
      if (nVal && nVal.length) this.updateResource()
      else this.resource = []
    }
  },
  methods: {
    updateResource() {
      this.resource = []
      this.resource.push({
        data: this.data,
        current: '',
        keyword: '',
        level: 1,
        title: this.title[0]
      })
    },
    handleClose(event, name) {
      console.log(event, name)
      this.$emit('on-delete', { list: this.data, name })
    },
    selectAll({ level, check, cat, key, keyword }) {
      const index = level - 2
      let current = ''
      let id = key || 0
      // 第二级开始计算
      if (index > -1 && !id) {
        current = this.resource[index].current
        const child = this.resource[index].data.filter((ret) => ret.name === current).pop()
        child && (id = child.id)
      }
      cat && (current = cat)
      this.$emit('on-select', {
        check,
        current,
        keyword,
        id,
        list: this.data
      })
    },
    pushChild(params) {
      const { item, level } = params
      const len = this.resource.length
      const data = item.children
      if (level <= len - 1) this.resource.splice(level, len - level)
      if (level === 1) {
        if (isArray(data)) {
          data.forEach((ret) => {
            const some = this.result.some((item) => item.key === ret.id)
            this.$set(ret, 'check', some)
          })
          this.resource.push({
            data,
            current: '',
            keyword: '',
            level: level + 1,
            title: this.title[level] || item.name
          })
          this.resource[level - 1].current = item.name
          if (this.resourceTitle) {
            this.$emit('on-title', this.currents(level)) // 根据resource的currrent显示标题
            const boolBar = this.$refs.bar && this.$refs.bar.$el
            if (boolBar && typeof boolBar.scrollLeft === 'number') {
              this.$nextTick(() => {
                boolBar.scrollLeft = 2020
              })
            }
          }
        }
      }
    },
    currents(index) {
      const arr = []
      while (--index > -1) {
        arr.push(this.resource[index].current)
      }
      return arr
    }
  },
  created() {
    this.updateResource()
  }
}
</script>
<style lang="scss" scoped>
.c-selecter {
  position: relative;

  .c-select-box {
    border: solid 1px #dee4f5;
    overflow-x: auto;

    .c-select-flex {
      display: flex;
      flex-wrap: nowrap;

      .c-selecter-item {
        min-width: 200px;
        height: 450px;
        display: inline-block;
        border-left: solid 1px #dee4f5;

        &:first-child {
          border-left: none;
        }
      }
    }
  }

  .c-pop-tip {
    width: 100%;
  }

  .c-tag-item {
    width: 90%;
    margin: 8px 8px 0;
    padding: 2px 6px;
    display: block;
    font-size: 14px;
    height: 28px;

    ::v-deep .ivu-icon-ios-close {
      float: right;
      margin-top: 5px;
    }

    ::v-deep span.ivu-tag-text {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 90%;
      display: inline-block;
    }
  }

  ::v-deep .ivu-checkbox-wrapper {
    .ivu-checkbox {
      margin-right: 0;
    }
  }
}
</style>
